const prefix = '@komigen/mobile-frontend/dga';

export const CLEAR = `${prefix}/CLEAR`;
export const ERROR = `${prefix}/ERROR`;
export const SESSION_UPDATE = `${prefix}/SESSION_UPDATE`;
export const UPDATE_DETAILS = `${prefix}/UPDATE_DETAILS`;
